import type { FC } from 'react';

import type { IconType } from '../../../../icons/constants';
import Icon, { ICONS } from '../../../../icons/icon';
import { DYNAMIC_ICON } from '../constants';
import type { MenuItem } from '../types';

import styles from './action_icon.module.css';

type Props = Pick<MenuItem, 'icon' | 'label'>;

const overriddenSizes: { [key in IconType]?: number } = {
  [ICONS.Tick]: 16,
};

const ActionIcon: FC<Props> = ({ icon, label }) => {
  if (!icon) {
    return null;
  }
  if (icon === DYNAMIC_ICON) {
    if (!label) {
      return null;
    }
    const letters = label.split(' ').map((word) => word.charAt(0));
    return (
      <span className={styles.letters}>
        {((letters[0] || '') + (letters[1] || '')).toUpperCase()}
      </span>
    );
  }
  return (
    <div className={styles.icon_container}>
      <Icon size={overriddenSizes[icon] ?? 18} icon={icon} />
    </div>
  );
};

export default ActionIcon;
